import { connect, Dispatch } from 'react-redux';
import { author, comment, fetchReview, rateReview, submitReview } from '../../actions';
import { Store } from '../../store';
import { ReviewActions, ReviewAttributes, ReviewEditor } from './review';

function mapStoreToAttributes(store: Store): ReviewAttributes {
  return {
    review: store.review,
    files: store.files,
    token: store.token || window.location.pathname.split('/').splice(-1)[0],
    error: store.error,
    readOnly: store.review && store.review.readOnly
  };
}

function mapDispatchToActions(dispatch: Dispatch<Store>): ReviewActions {
  return {
      author: text => dispatch(author(text)),
      rate: rank => dispatch(rateReview(rank)),
      comment: text => dispatch(comment(text)),
      fetch: token => dispatch(fetchReview(token)),
      submit: (files, review, token, done) => dispatch({...submitReview(files, review, token), done})
  };
}

export default connect(mapStoreToAttributes, mapDispatchToActions)(ReviewEditor);
